(() => {
  const sectionSelector = '[data-thom-featured-fit]';
  const tabSelector = '[data-thom-mode-tab]';

  function activateTab(section, nextTab, shouldFocus = false) {
    const tabs = Array.from(section.querySelectorAll(tabSelector));
    const panel = section.querySelector('[data-thom-mode-panel]');
    const status = section.querySelector('[data-thom-mode-status]');
    const mode = nextTab.dataset.thomModeValue;

    tabs.forEach((tab) => {
      const isActive = tab === nextTab;
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
    });

    section.dataset.thomMode = mode;

    if (panel) {
      panel.setAttribute('aria-labelledby', nextTab.id);
    }

    if (status) {
      status.textContent = `${nextTab.textContent.trim()} mode selected.`;
    }

    if (shouldFocus) nextTab.focus();
  }

  function moveTab(section, currentTab, direction) {
    const tabs = Array.from(section.querySelectorAll(tabSelector));
    const currentIndex = tabs.indexOf(currentTab);
    if (currentIndex < 0) return;

    const nextIndex = (currentIndex + direction + tabs.length) % tabs.length;
    activateTab(section, tabs[nextIndex], true);
  }

  function initSection(section) {
    if (!section || section.dataset.thomFeaturedFitReady === 'true') return;

    const tabs = Array.from(section.querySelectorAll(tabSelector));
    if (!tabs.length) return;

    section.dataset.thomFeaturedFitReady = 'true';

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activateTab(section, tab));

      tab.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          event.preventDefault();
          moveTab(section, tab, 1);
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          event.preventDefault();
          moveTab(section, tab, -1);
        } else if (event.key === 'Home') {
          event.preventDefault();
          activateTab(section, tabs[0], true);
        } else if (event.key === 'End') {
          event.preventDefault();
          activateTab(section, tabs[tabs.length - 1], true);
        }
      });
    });
  }

  function initAll(root = document) {
    root.querySelectorAll(sectionSelector).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
